import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import "./StoryShareModal.css";

const StoryShareModal = ({ isOpen, onClose, story }) => {
    const [step, setStep] = useState("choose"); // "choose", "email", "social", "copy"
    const [email, setEmail] = useState("");
    const { t } = useTranslation();

    if (!isOpen) return null;
    if (!story._id || !story.title) {
        return (
            <div>
                <p className='form-error'>{t('storyShare.shareStoryNotFound')}</p>
            </div>
        );
    }
    const storySlug = story.slug;
    const storyTitle = story.title;
    const shareUrl = `${window.process.env.META_URL}/story/${storySlug}`;

    const copyToClipboard = () => {
        navigator.clipboard.writeText(shareUrl);
        alert(t('storyShare.linkCopied'));
    };

    const shareByEmail = () => {
        window.location.href = `mailto:${email}?subject=${t('storyShare.shareByEmailSubject')}&body=${t('storyShare.shareByEmailBody', {title: storyTitle, shareUrl: shareUrl})}`;
    };

    const shareOnFacebook = () => {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`, "_blank");
    };

    const shareOnTwitter = () => {
        window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(t('storyShare.shareOnTwitterText', {shareUrl: shareUrl}))}`, "_blank");
    };

    const shareOnWhatsApp = () => {
        window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(t('storyShare.shareOnWhatsApp', {shareUrl: shareUrl}))}`, "_blank");
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
            {step === "choose" && (
                <>
                    <h2>{t('storyShare.modalTitle', {title: storyTitle})}</h2>
                    <p>{t('storyShare.howtoShare')}</p>
                    <div className="share-options">
                        <button className="share-btn email" onClick={() => setStep("email")}>
                            <i className="fa-solid fa-envelope"></i>
                            <span>{t('storyShare.email')}</span>
                        </button>
                        <button className="share-btn social" onClick={() => setStep("social")}>
                            <i className="fa-solid fa-share-alt"></i>
                            <span>{t('storyShare.socialMedia')}</span>
                        </button>
                        <button className="share-btn copy" onClick={() => setStep("copy")}>
                            <i className="fa-solid fa-link"></i>
                            <span>{t('storyShare.copyLink')}</span>
                        </button>
                    </div>
                </>
            )}

            {step === "email" && (
                <>
                    <h2>{t('storyShare.shareByEmail')}</h2>
                    <p>{t('storyShare.enterEmail')}</p>
                    <div className="share-by-email">
                        <input
                            type="email"
                            placeholder={t('storyShare.emailPlaceholder')}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        <button className="big-button action-button" onClick={shareByEmail}>
                            <i className="fa-solid fa-envelope"></i>
                            <span>{t('storyShare.sendEmail')}</span>
                        </button>
                    </div>
                </>
            )}

            {step === "social" && (
                <>
                    <h2>{t('storyShare.shareBySocialMedia')}</h2>
                    <button onClick={shareOnFacebook} className="facebook-btn social-button">
                        <i className="fa-brands fa-facebook"></i>
                        <span>Facebook</span>
                    </button>
                    <button onClick={shareOnTwitter} className="twitter-btn social-button">
                        <i className="fa-brands fa-x-twitter"></i>
                        <span>Twitter</span>
                    </button>
                    <button onClick={shareOnWhatsApp} className="whatsapp-btn social-button">
                        <i className="fa-brands fa-whatsapp"></i>
                        <span>WhatsApp</span>
                    </button>
                </>
            )}

            {step === "copy" && (
                <>
                    <h2>{t('storyShare.copyTheLink')}</h2>
                    <p>{t('storyShare.shareByLinkSubTitle')}</p>
                    <div className="share-by-copy-link">
                        <input type="text" value={shareUrl} readOnly />
                        <button className="big-button action-button" onClick={copyToClipboard}>
                            <i className="fa-solid fa-copy"></i>
                            <span>{t('storyShare.copy')}</span>
                        </button>
                    </div>
                </>
            )}

{/* 
                {/* Share Link *}
                <div className="share-link">
                    <input type="text" value={shareUrl} readOnly />
                    <button onClick={copyToClipboard}>{t('storyShare.copy')}</button>
                </div>

                {/* Email Sharing *}
                <div className="email-share">
                    <input
                        type="email"
                        placeholder="Enter email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <button onClick={shareByEmail}>{t('storyShare.sendEmail')}</button>
                </div>

                {/* Social Media Buttons *}
                <div className="social-buttons">
                    <button onClick={shareOnFacebook} className="facebook-btn">Facebook</button>
                    <button onClick={shareOnTwitter} className="twitter-btn">Twitter</button>
                    <button onClick={shareOnWhatsApp} className="whatsapp-btn">WhatsApp</button>
                </div>

 */}                {/* Close Modal */}
                <div className="share-buttons">
                    {step !== "choose" && (
                    <button className="back-btn" onClick={() => setStep("choose")}>
                        <i className="fa-solid fa-left-long"></i>
                        <span>{t('storyShare.back')}</span>
                    </button>
                    )}
                    <button className="close-btn" onClick={onClose}>
                        <i className="fa-solid fa-xmark"></i>
                        <span>{t('storyShare.close')}</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default StoryShareModal;
